import api from 'api';

import { defaultPagination } from './general';

type GetAccessoryTypesType = {id: number | string}

export const listAccessoryTypes = async (params) => api().get('/accessory_types', { params: { ...defaultPagination, ...params } });

export const getAccessoryTypes = async ({ id }:GetAccessoryTypesType) => api().get(`/accessory_types/${id}`);

export const createAccessoryTypes = async ({ data }) => api().post('/accessory_types', data);

export const updateAccessoryTypes = async ({ id, data }) => api().put(`/accessory_types/${id}`, data);
